import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "message-marked",
        innerHTML: $setup.parsedContent
      }, null, 8, _hoisted_1),
      ($setup.image)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "rich-image-previewer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeImage && $setup.closeImage(...args)))
          }, [
            _createElementVNode("img", {
              class: "rich-image-preview",
              style: {
          transform: `scale(1) rotate(0deg)`,
        },
              src: $setup.imageSrc
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}